import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";

let stripePromise: Promise<Stripe> | undefined;

export function getStripe(): Promise<Stripe> {
  if (!stripePromise) {
    const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
    if (!key) {
      return Promise.reject(
        new Error("VITE_STRIPE_PUBLISHABLE_KEY is required")
      );
    }
    stripePromise = loadStripe(key)
      .then((stripe) => {
        if (!stripe) throw new Error("Stripe is unavailable");
        return stripe;
      })
      .catch((error: unknown) => {
        stripePromise = undefined;
        throw error;
      });
  }
  return stripePromise;
}
